import { useMemo, memo } from 'react';
import * as React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

// Imports => Utilities
import { AcUUID, AcIsSet, AcIsArray } from '@opp/ui-kit';

// Imports => Atoms
import AcSettlementListItem from '@atoms/ac-settlement-list-item/ac-settlement-list-item';
import { useGetSettlementsQuery } from '@src/api/openapi/merchantApi';
import { useSettlementsParams } from '@src/views/ac-settlements-overview/ac-settlements-overview';

const _CLASSES = {
  MAIN: 'ac-settlements-list',
  CONTAINER: 'ac-settlements-list__container',
};

const AcSettlementsList: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ className }) => {
  const {values: {date, order, filter, page} } = useSettlementsParams();
  const {data = {}} = useGetSettlementsQuery({dateStart: date, order, status: filter, page});
  const items = data.data;

  const getContainerClassNames = useMemo(() => {
    return clsx(_CLASSES.CONTAINER);
  }, []);

  const getMainClassNames = useMemo(() => {
    return clsx(_CLASSES.MAIN, className);
  }, [className]);

  const renderItems = useMemo(() => {
    if (!AcIsSet(items) || !AcIsArray(items)) return null;

    const collection = items;
    const len = collection.length;
    let n = 0;
    let result = [];

    for (n; n < len; n++) {
      const item = collection[n];

      const object = (
        <AcSettlementListItem
          key={`ac-settlement-list-item-${item.uid}`}
          data={item}
        />
      );

      result.push(object);
    }

    return result;
  }, [items]);

  return (
    <div className={getMainClassNames}>
      <div className={getContainerClassNames}>{renderItems}</div>
    </div>
  );
};

AcSettlementsList.propTypes = {
  /**
     * For CSS customization
     */
  className: PropTypes.string,
};

export default memo(AcSettlementsList);
